import React from "react";
import PropTypes from "prop-types";
import useWindowSize from "../../_Common/useWindowSize";
import { MOBILE_BREAKPOINT } from "../../_Common/constants";

const Video = ({ url, urlMobile }) => {
  const size = useWindowSize();

  const videoUrl =
    size.width < MOBILE_BREAKPOINT && urlMobile != null ? urlMobile : url;

  return (
    <video
      key={videoUrl}
      autoPlay={true}
      loop={true}
      muted={true}
      playsInline={true}
      width="100%"
    >
      <source src={videoUrl} type="video/mp4" />
    </video>
  );
};

Video.propTypes = {
  url: PropTypes.string.isRequired
};

export default Video;
